import { createFileRoute } from "@tanstack/react-router"

import { IncomingPurchaseOrdersTab } from "@/screens/WarehouseReceiving/subfeatures/Incoming/components"

export const Route = createFileRoute("/app/warehouse-receiving/incoming/$goodsReceiptId/_layout/purchase-orders")({
  component: IncomingPurchaseOrdersTab,
})
